export const SHOW_ACTIONS = 'SHOW_ACTIONS';
export const HIDE_ACTIONS = 'HIDE_ACTIONS';

export const showActions = () => {
    return {type: SHOW_ACTIONS}
}

export const hideActions = () => {
    return {type: HIDE_ACTIONS}
}